import { RootState } from '../../../setup/store/store';
import { apiConfigurationEndpoints } from '../../api-configuration/store/api-configuration.endpoints';
import { pushNotificationHelper } from '../helpers/push-notitifcation.helper';
import { setStatus, setKey } from './push-notifications.slice';
import { pushNotificationEndpoints } from './push-notification.endpoints';
import { appListener } from '../../../setup/store/listener.middlerware';

appListener.startListening({
    matcher: apiConfigurationEndpoints.endpoints.apiConfiguration.matchFulfilled,
    effect: async (action, listenerApi) => {
        const pushInit = await pushNotificationHelper.init();

        const applicationServerKey = action.payload.pushApplicationServerKey;
        if (applicationServerKey) {
            listenerApi.dispatch(setKey({ applicationServerKey }));
            listenerApi.dispatch(setStatus(pushInit));
        } else {
            listenerApi.dispatch(
                setStatus({
                    status: 'error',
                    error: { message: 'applicationServerKey not found' },
                }),
            );
        }
    },
});

appListener.startListening({
    actionCreator: setStatus,
    effect: async (action, listenerApi) => {
        const status = action.payload.status;
        const state = listenerApi.getState() as RootState;
        const { applicationServerKey } = state.pushNofications;
        if (status === 'granted') {
            try {
                const sub = await pushNotificationHelper.getSubscription(applicationServerKey);
                void listenerApi.dispatch(
                    pushNotificationEndpoints.endpoints.pushNotificationSubscribe.initiate(
                        sub.toJSON(),
                    ),
                );
            } catch (error: any) {
                listenerApi.dispatch(
                    setStatus({
                        status: 'error',
                        error: { message: `Error getting subscription: ${error}` },
                    }),
                );
            }
        }
    },
});
